import React from 'react'
import styles from './Charm.module.css'
import CharmSection from './CharmSection'

export default function Charm() {
    const sections = [
        {
            className: styles.charm1,
            title: (
                <>
                    <span className={styles.orange}>掲載し放題</span>
                    の「求人」、
                    <br />
                    会社・ブランド
                    <br />
                    特設ページも<span className={styles.orange}>無料</span>
                    で公開
                </>
            ),
            description:
                '求人は作り放題で、求人掲載費用は無料、掲載期限もなし。好きなだけ求人を作成して欲しい飲食人材へアピールできます。さらに、求人を作成する過程で会社、ブランド特設ページが出来上がり、会社、ブランド単位でのアピールも可能。',
        },
        {
            className: styles.charm2,
            title: (
                <>
                    <span className={styles.orange}>ビジョン・想い</span>が
                    <br />
                    伝わる「求人」
                </>
            ),
            description:
                '求人には「どんなことをやっているか」「こんな人と働きます」「ここにこだわっています」「こんなことやります」の項目があり、それぞれ写真を最大4枚用いて、仕事内容の魅力や会社、ビジョン、一緒に働くメンバーをアピールできます。',
        },
        {
            className: styles.charm3,
            title: (
                <>
                    応募状況が
                    <span className={styles.orange}>一目でわかる、</span>
                    <br />
                    「採用管理画面」
                </>
            ),
            description:
                'モダンなデザインの採用管理画面で、応募者の管理、求人作成/編集、メッセージ対応などができます。特に応募対応、メッセージ対応は、少しでも時間が空くと求職者が離れてしまうため今やるべきことを強調して表示しています。',
        },
        {
            className: styles.charm4,
            title: (
                <>
                    <span className={styles.orange}>サクサク進む、</span>
                    <br />
                    「求人作成画面」
                </>
            ),
            description:
                '求人作成画面では、ストレスなく求人を作れるように、1ステップごと何を入力すれば良いかわかりやすく表示。さらに、記入した内容が求職者にどのように表示されるわかるように、右側にリアルタイムプレビュー機能を導入しています。',
        },
        {
            className: styles.charm5,
            id: 'agent_jump',
            title: (
                <>
                    募集要件に<span className={styles.orange}>マッチした</span>
                    <br />
                    「エージェントサポート」
                </>
            ),
            description:
                '飲食企業様が求人を作成し、採用活動をするのとは別に、弊社キャリアアドバイザーが募集要件にマッチした人材をご推薦することも可能です。エージェントサポートでは、面接の日程調整や条件交渉、入社までのサポートを行います。',
        },
    ]

    return (
        <section id='charm' className={styles.charm}>
            <h2>
                採用DXプラットフォーム
                <br />
                <span>「FoodsLabo」</span>の魅力
            </h2>
            {sections.map((section, index) => (
                <CharmSection
                    key={index}
                    title={section.title}
                    description={section.description}
                    className={section.className}
                    id={section.id}
                />
            ))}
            <a href='#form' rel='noopener noreferrer'>
                お問い合わせはこちら
            </a>
        </section>
    )
}
